import { useEffect, useState } from "react";
import { db } from "../lib/firebase";
import { collection, onSnapshot } from "firebase/firestore";

export function usePlaylists(env, client) {
  const [loadedPlaylists, setLoadedPlaylists] = useState(false);
  const [playlists, setPlaylists] = useState(null);

  useEffect(() => {
    setLoadedPlaylists(false);
    if (!client) {
      setLoadedPlaylists(true);
      return () => [];
    }
    const ref = collection(db, "kiosk", env, "client", client, "playlists");

    // onSnapshot = reactivo + offline + cache
    const unsub = onSnapshot(ref, (snapshot) => {
      const data = {};

      snapshot.docs.forEach((doc) => {
        data[doc.id] = {
          id: doc.id,
          ...doc.data()
        };
      });

      setPlaylists(data);
      setLoadedPlaylists(true);
    });

    return () => unsub();
  }, [env, client]);

  return { loadedPlaylists, playlists };
}